export default "__VITE_ASSET__yrlk3hJF__"